import React from "react"
import SequencesImage from "../../../components/staticQuery/features/automation/SequencesImage"
import ContactSegmentationImage from "../../../components/staticQuery/features/contact-management/ContactSegmentationImage"
import DragAndDropBuilderImage from "../../../components/staticQuery/features/extras/DragAndDropBuilderImage"
import TextMessageOptInImage from "../../../components/staticQuery/features/lead-capture/TextMessageOptInImage"
import SplitBranchesImage from "../../../components/staticQuery/features/automation/SplitBranchesImage"
import EverythingBlob from "../../../images/home/everythingBlob.svg"
import PowerBlob from "../../../images/home/powerBlob.svg"
import MessageBlob from "../../../images/home/messageBlog.svg"
import EverythingInOnePlaceImage from "../../../components/staticQuery/features/home/EverythingInOnePlaceImage"
import OpenHouseImage from "../../../components/staticQuery/features/home/PowerMeetsSimplicityImage"
import P from "../../../components/typography/P"
import YourMessageDeliveredImage from "../../../components/staticQuery/features/home/YourMessageDeliveredImage"

const EverythingInOnePlaceText = () => (
  <>
    <P>
      Tired of piecing together multiple software tools that were never designed
      to work together to accomplish everyday marketing and sales tasks?
    </P>
    <P>
      MindMe combines the features you need in one software platform designed to
      work perfectly together.
    </P>
  </>
)

const PowerMeetsSimplicityText = () => (
  <>
    <P>
      Marketing tools designed for professional marketers are costly and
      complex. We combine advanced features at a price every business can
      afford.
    </P>
    <P>
      MindMe offers an intuitive, cutting-edge design in an easy-to-use
      interface. Take your marketing to the next level.
    </P>
  </>
)

const YourMessageDelivered = () => (
  <>
    <P>
      Email alone is less effective today as spam and email volume have grown.
      Text is superior for deliverability and urgency, but it’s more costly.
      What if there was a better way?
    </P>
    <P>
      MindMe uniquely combines these communication channels along with other
      advanced techniques to deliver your message and increase engagement. We
      then segment your Contacts based on activity and responses for better
      targeting.
    </P>
  </>
)

const homePageData = [
  {
    title: "Everything in One Place",
    description: <EverythingInOnePlaceText />,
    graphic: <EverythingInOnePlaceImage />,
    imageLeft: false,
    imageHalf: true,
    benefits: [
      { benefitName: "Streamlines your marketing efforts" },
      { benefitName: "Eliminates the need to connect multiple systems" },
      { benefitName: "Quicker to get started and see results" },
      { benefitName: "Eliminates the cost of multiple tools" },
    ],
    link: "/features/contact-management",
    tint: "#f1f5f8",
    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 6vw))",
    blob: EverythingBlob,
    className: "padding-tb-0 graphic-image-container",
  },
  {
    title: "Power Meets Simplicity",
    description: <PowerMeetsSimplicityText />,
    graphic: <OpenHouseImage />,
    imageLeft: true,
    benefits: [
      { benefitName: "Professional grade features" },
      { benefitName: "Easy-to-use & intuitive design" },
      { benefitName: "Scales with you as your needs grow" },
      { benefitName: "Plans for every need" },
    ],
    link: "/features/marketing-tools",
    clipPath: false,
    blob: PowerBlob,
    className: "padding-tb-0 padding-b-0 power-img-container",
  },
  {
    title: "Your Message Delivered",
    description: <YourMessageDelivered />,
    graphic: <YourMessageDeliveredImage />,
    imageLeft: false,
    benefits: [
      { benefitName: "Multi-channel communication" },
      { benefitName: "Increased engagement over email alone" },
      { benefitName: "Instant notifications on activity and responses" },
      { benefitName: "Smarter segmentation, targeting & routing" },
    ],
    link: "/features/lead-capture",
    tint: "#f1f5f8",
    clipPath: "polygon(0 6vw,100% 0,100% 100%, 0% 100%)",
    blob: MessageBlob,
    className: "padding-b-0",
  },
]

export default homePageData
